module.exports = require("@embedpdf/plugin-thumbnail/react");